// Colunas GERADAS pelo banco (GENERATED ALWAYS … STORED). O Postgres recusa
// qualquer valor nelas — e recusa a LINHA INTEIRA: "cannot insert a
// non-DEFAULT value into column". `cnpj_normalizado` nasceu com a migration
// 20260830 (aplicada em 22/10/2026); a partir daí toda linha carregada a trazia,
// o modal de edição espalha a linha carregada (`...editing`) no registro, e
// editar/concluir qualquer ficha existente passou a falhar (caso Paradiesel,
// 26/10/2026). Nunca vão do navegador para o banco.
//
// POR TABELA, e não uma lista global: `total` é gerada em
// transferencias_carteira, mas é nome comum demais para podar em todo lugar.
// Lista conferida no banco em 26/10/2026:
//   SELECT table_name, column_name FROM information_schema.columns
//    WHERE table_schema = 'public' AND is_generated = 'ALWAYS';
// Coluna gerada nova → acrescente aqui.
//
// Módulo próprio porque database.js e filaGravacao.js precisam dele, e um
// importar o outro fecharia um ciclo.
export const COLUNAS_GERADAS = {
  credenciamentos: ["cnpj_normalizado"],
  transferencias_carteira: ["total"],
};

export const semColunasGeradas = (tabela, linha) => {
  if (!linha || typeof linha !== "object") return linha;
  const geradas = COLUNAS_GERADAS[tabela] || [];
  if (!geradas.length) return linha;
  const out = { ...linha };
  for (const c of geradas) delete out[c];
  return out;
};
